<template>

    <div class="grey lighten-2" style="height: 100%;">
        <div class="d-flex pa-5">
            <div>
                <div class="text-h4 font-weight-black">
                    Prosjekt: {{this.project.toUpperCase()}}
                </div>
                <div class="text-h5 font-weight-black">
                    Uke {{moment().isoWeek()}} leveranser: {{deliveries.length}}
                </div>
            </div>

            <div class="d-flex ml-auto my-auto">
                <v-btn @click="() => { this.$refs.calendar.scrollToTime('06:30'); }" color="primary">
                    <v-icon left>mdi-refresh</v-icon>
                    nullstill
                </v-btn>
                <div class="mx-1"></div>
                <v-btn @click="back" color="primary">
                    <v-icon left>mdi-cog</v-icon>
                    innstillinger
                </v-btn>
            </div>

        </div>

        <div class="red lighten-2" style="height: 80vh;">
            <v-calendar ref="calendar" :events="deliveries" event-name="name" :event-color="eventColor" event-start="startDate" event-end="endDate" locale="no" type="week" show-week :weekdays="[1,2,3,4,5]" :start="start" :end="end">
                <template v-slot:event={event}>
                    <div class="text-body-2">
                        <div class="text-uppercase text-truncate d-block">{{event.name}}</div>
                        <div>{{moment.unix(event.start).format("HH:mm")}} - {{moment.unix(event.end).format("HH:mm")}}, {{event.zone.name}}</div>
                        <div v-for="evt in event.resources" :key="evt.id" style="font-size: 0.8em; line-height: 1em;">
                            <div>{{evt.name}} x {{evt.usage}}</div>
                        </div>
                    </div>
                </template>
            </v-calendar>
        </div>

        <v-snackbar centered color="error" timeout="-1" v-model="alert">
            Tilgang til infoskjerm er sannsynligvis fjernet.
        </v-snackbar>

    </div>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
export default {
    props: [
        "id",
        "project",
        "autorefresh"
    ],
    data() {
        return {
            deliveries: [],
            moment: moment,
            intervalTimeout: undefined,
            alert: false,
            start: moment().startOf('isoWeek').format('YYYY-MM-DD'),
            end: moment().endOf('isoWeek').format('YYYY-MM-DD'),
        }
    },
    methods: {
        back: function() {
            this.$router.push("/settings");
        },
        async loadDeliveries() {
            this.start = moment().startOf('isoWeek').format('YYYY-MM-DD');
            this.end = moment().endOf('isoWeek').format('YYYY-MM-DD');

            let url = `/infoscreen/${this.id}`;
            if(!axios.defaults.params || !axios.defaults.params.project){
                url = `${url}?project=${this.project}`
            }
            
                axios.get(url)
                .then((response) => {
                    this.deliveries = response.data.data.map(d => {
                        d.startDate = moment.unix(d.start).toDate();
                        d.endDate = moment.unix(d.end).toDate();
                        d.timed = true;
                        return d;
                    });
                })
                .catch((err) => {
                    if(err.response.status === 404 && err.response.data && err.response.data.success === false){
                        clearInterval(this.intervalTimeout);
                        this.alert = true;
                        this.deliveries.splice(0);
                    }
                    this.$store.dispatch("snackbar", {
                        show: true,
                        text: "Mangler rettigheter.",
                        color: "error",
                    });
                });
            
        },
        eventColor: function(event) {
            return event.zone.color;
        }
    },
    mounted() {
        this.loadDeliveries();
        this.$refs.calendar.scrollToTime("06:30");
        if(this.autorefresh === "true"){
            this.intervalTimeout = setInterval(() => {
                this.loadDeliveries();
            }, 5*60*1000);
        }
       
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", false);
            vue.$store.commit("showNavDrawer", false);
        });
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.intervalTimeout);
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    }
}
</script>